<template>
  <div v-if="show" class="device_groups_stat">

    <h4 class="title">
      Device Groups Stat
    </h4>

    <p v-for="(device_group, key_stat) in device_groups_stat" :key="key_stat">
      <router-link :to="get_name_link(device_group.group_id)" class="device_group">
        <span>{{ device_group.name }}: </span>
      </router-link>
      <span>{{ device_group.online }} </span>
      <span> / </span>
      <span>{{ device_group.total }}</span>
    </p>

  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

export default {
  name: 'DeviceGroupsStats',
  components: {
  },
  props: ['device_groups_stat'],
  data () {
    return {
      loading: false,
      show: true,
      temp: '',
      date: [],
      actions: []
    }
  },

  mounted () {
  },

  watch:{

  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    get_name_link (group_id) {
      return {path: '/device_group/' + group_id}
    },
  },
}

</script>
<style lang='scss' scoped>
  .device_groups_stat{
    padding: 5px;
    .title{
      margin-bottom: 10px;
    }
    // .device_group{
    //   color: #252422;
    // }
  }
</style>
